import axiosInstance from "../interceptor/interceptor"; // Assuming axiosInstance is correctly configured
import dictionary from "../dictionary";

const { posts } = dictionary;

const postsServices = {
  getPosts: (queryString: string = '') => axiosInstance.get(`${posts.getPosts()}${queryString}`),
  addPost: (endpoint: string, postData: any = {}) => axiosInstance.post(endpoint, postData),
  updatePost: (endpoint: string, postData: any = {}, queryString: string = '') =>
    axiosInstance.put(`${endpoint}${queryString}`, postData),
  multipleFundReq: (endpoint: string, postData:any = {}) => axiosInstance.post(endpoint, postData)
};

export default postsServices;